import React, {memo} from 'react'
import { strings } from '../../../strings/strings'

export const TravelStartDateDescription = memo(() => {

    return (
        <>
            <p><span className='tooltip-important-text'>{strings.travel.forms.startDateDesc1}</span></p>
            <p>
                <span>{strings.travel.forms.startDateDesc2}</span>
                <span className='tooltip-important-text'>{strings.travel.forms.startDateDesc3}</span>
            </p>
            <p>
                <span>{strings.travel.forms.startDateDesc4}</span>
                <span className='tooltip-important-text'>{strings.travel.forms.startDateDesc5}</span>
            </p>
        </>
    )
})